export default "__VITE_ASSET__BUE0pc3V__"